export const groupMatchesByDate = (matches, timezone) => {
    return PULSE.app.common.arrayHelper.groupBy(matches, (match) => {
        // Group cancelled/postponed matches under their status keys

        if (
            PULSE.app.common.match.getMatchStatus(match.status) ===
            PULSE.app.common.CONSTANTS.MATCH_STATUS.TBC
        ) {
            return `${PULSE.app.common.CONSTANTS.MATCH_STATUS.TBC}_${
                match.round.roundNumber
            }_${moment(match.round.utcStartTime || match.utcStartTime)
                .tz(PULSE.app.common.CONSTANTS.TIMEZONES.AEST)
                .format('YYYYMMDD')}`;
        }

        if (PULSE.app.common.match.cancelledOrPostponed(match.status)) {
            return PULSE.app.common.CONSTANTS.UNCONFIRMED_GROUP;
        }

        return moment(match.utcStartTime).tz(timezone).format('YYYYMMDD');
    });
};
